import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { copy } from "@/lib/copy";
import { copyExp } from "@/lib/copyExp";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("es");

  useEffect(() => {
    try {
      localStorage.setItem("dvz-lang", lang);
    } catch {}
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: { ...copy[lang], ...copyExp[lang] } }),
    [lang]
  );
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
